import React, { PropsWithChildren } from 'react';

import { css, cx } from '@emotion/css';
import MuiCardActions from '@mui/material/CardActions';

import { useStyles } from '@/hooks/useStyles.ts';
import { Theme } from '@/theme/CreateTheme.ts';
import { AtomProps } from '@/uiKit/atoms/utils/AtomTypes.ts';

export type BaseCardFooterProps = PropsWithChildren<{}>;

export type CardFooterProps = AtomProps<BaseCardFooterProps>;

export const CardFooter: React.FC<CardFooterProps> = ({
  children,
  className,
  ...props
}) => {
  const styles = useStyles(makeStyles);

  return (
    <MuiCardActions className={cx(styles.root, className)} {...props}>
      {children}
    </MuiCardActions>
  );
};

const makeStyles = (theme: Theme) => ({
  root: css({
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(10, 32),
    gap: theme.spacing(20),
    width: '100%',
  }),
});
